import { createFileRoute, redirect } from "@tanstack/react-router"
import { meQueryOptions } from "@/features/auth/api/auth.queries"
import { childrenQueryOptions } from "@/features/children/api/children.queries"
import { AppShell } from "@/features/shell/AppShell"
import { ApiError } from "@/shared/utils/apiError"

export const Route = createFileRoute("/_app")({
  // The me query is never persisted, so this hits the network once per app boot.
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData(meQueryOptions)
    } catch (err) {
      // Only an actual auth rejection means logged out. A network failure
      // (offline PWA boot, API down) falls through so cached reads still render.
      if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
        throw redirect({ to: "/login" })
      }
    }
  },
  // Prefetch children so child-dependent pages read via useSuspenseQuery without a waterfall.
  loader: ({ context }) => context.queryClient.ensureQueryData(childrenQueryOptions),
  component: AppShell,
})
